module.exports = __webpack_public_path__ + "polreg2-e837754152b4cb6c496cb26b077460e3.png";